import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { database as realtimeDb } from "../FirebaseConfig"; // Import Firebase Realtime DB
import { ref, onValue } from "firebase/database";
import { Link } from "react-router-dom"; // For navigation

const AnnouncementCarousel = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const announcementsRef = ref(realtimeDb, "announcements");

    // Fetch announcements from Firebase Realtime Database
    const unsubscribe = onValue(announcementsRef, (snapshot) => {
      if (snapshot.exists()) {
        const data = Object.values(snapshot.val()); // Convert Firebase object to array
        setAnnouncements(data);
      }
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (announcements.length > 0) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) =>
          prevIndex === announcements.length - 1 ? 0 : prevIndex + 1
        );
      }, 3000); // Change announcement every 3 seconds

      return () => clearInterval(interval);
    }
  }, [announcements]);

  if (announcements.length === 0) {
    return null; // Don't render if no announcements are available
  }

  return (
    <div 
      style={{
        backgroundColor: announcements[currentIndex]?.bgColor || "#f47d02",
      }}
      className="w-full fixed top-0 text-center left-0 z-50   overflow-hidden"
    >
      <div className="relative h-8 flex items-center justify-center">
        <AnimatePresence mode="wait">
          <motion.div
            key={currentIndex}
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -20, opacity: 0 }}
            transition={{ duration: 0.5 }}
            className="text-sm sm:text-size-4 font-semibold flex items-center space-x-2"
            style={{ color: announcements[currentIndex]?.textColor || "#fff" }}
          >
            <Link
              to={announcements[currentIndex]?.link || "#"}
              className="flex text-xs md:text-sm items-center space-x-2 hover:underline"
            >
              <span>{announcements[currentIndex]?.text}</span>
              {/* {announcements[currentIndex]?.icon && (
                <img
                  src={announcements[currentIndex]?.icon}
                  alt="icon"
                  className="h-4 w-4"
                />
              )} */}
            </Link>
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
};

export default AnnouncementCarousel;
